'use strict'
var approval = angular.module('approvalsModule',[
	'ui.router',
	'servicesModule',
	'ngResource',
	"ngTable",
	'ngBootstrap'
]);

require('./allapprovals/js/directive/allApprovalsDirective.js')(approval);
require('./allapprovals/js/allApprovalsController.js')(approval);



//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/approvalsModule/approvalsModule.js
// module id = 492
// module chunks = 0